<template>
  <collapsible-section class="_pt0 _pb0" :collapsed="false">
    <template #headerText>
      <p class="color-leaf">Related Members</p>
    </template>

    <template #headerActions>
      <tool-tip
        message="You may not add dependents to a voided subscriber."
        :top="true"
        :show-tool-tip="primarySubscriberVoided"
      >
        <router-link
          tag="button"
          :disabled="primarySubscriberVoided"
          :to="{name: 'add-dependent', params: { primarySubscriberMemberCk: primarySubscriberCkToUseForDependents }}"
          class="_mls _mt0 btn white --sm"
          v-if="canAddDependent && !memberDetailsLoading && primarySubscriberCkToUseForDependents"
        >
          Add Dependent
        </router-link>
      </tool-tip>
    </template>
    <template #collapsibleSection>
      <async-loader v-if="memberDetailsLoading" />
      <div
        v-else
        container
        class="_ptxs _pbxs"
        v-for="(member, index) in memberDetails.member.relatedMembers"
        :key="index"
      >
        <div row class="_flex _mbxs align-center">
          <div class="_mr-auto">
            <p
              class="print-only"
            >
              {{ member.firstName }} {{member.lastName}}
            </p>
            <a
              @click="pushOrGo({ name: 'member-details', params: { subscriberCk: memberDetails.member.subscriberCk, memberCk: member.memberCk }})"
              class="color-black"
            >
              {{ member.firstName }} {{ member.lastName }}
            </a>
          </div>
          <div class="_ml-auto _flex align-center">
            <a
              v-if="memberManagementAllowed"
              @click="pushOrGo({ name: 'member-edit', params: { subscriberCk: memberDetails.member.subscriberCk, memberCk: member.memberCk }})"
              class="leaf"
            >
              EDIT MEMBER
            </a>
            <a
              v-else
              @click="pushOrGo({ name: 'member-details', params: { memberCk: member.memberCk } })"
              class="leaf"
            >
              VIEW MEMBER
            </a>
          </div>
        </div>
        <div grid="row wrap">
          <div column="s-6 m-2 l-2">
            <labeled-data label="Client's Member ID:" :data="member.clientHealthId" />
          </div>
          <div column="s-6 m-2 l-2">
            <labeled-data
              label="Date of Birth:"
              :data="formatDate(member.dateOfBirth)"
            />
          </div>
          <div column="s-6 m-2 l-2">
            <labeled-data
              label="Relationship:"
              :data="member.relationshipDescription"
            />
          </div>
          <div column="s-6 m-2 l-2">
            <labeled-data
              label="Effective Date:"
              :data="formatDate(member.coverageStartDate)"
            />
          </div>
          <div column="s-6 m-2 l-2">
            <labeled-data
              label="Term Date:"
              :data="formatDate(member.coverageEndDate)"
            />
          </div>
          <div column="s-6 m-2 l-2">
            <labeled-data
              label="Member Status:"
              :data="member.memberStatus === 'Y' ? 'Active' : 'Inactive'"
            />
          </div>
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import CollapsibleSection from '@sections/CollapsibleSection'
  import memberManagement from '@mixins/memberManagement'
  import formattable from '@mixins/formattable'
  import pushable from '@mixins/pushable'
  import LabeledData from '@molecules/LabeledData'
  import ToolTip from '@molecules/ToolTip'

  export default {
    mixins: [
      memberManagement,
      formattable,
      pushable
    ],
    props: {
      canAddDependent: {
        type: Boolean,
        default: true
      }
    },
    components: {
      CollapsibleSection,
      LabeledData,
      ToolTip
    }
  }
</script>
